<div class="row" style="padding: 2px;">

    <div class="col-xl-3 col-lg-3 col-md-3 select-container col-sm-3 mb-1 select-container">
        <label>Garant :
            
        </label>
        <input disabled  class="form-control custom-input" placeholder="Garant" autocomplete="off"
        [(ngModel)]="itemBareme.garant_libelle" name="garant_libelle" autocomplete="off" type="text" />
    </div>
    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px;">
        <label>Codification:
            
        </label>
        <input disabled  class="form-control custom-input" disabled
            placeholder="Codification" autocomplete="off" [(ngModel)]="itemBareme.codification" name="codification"
            autocomplete="off" type="text" />
    </div>

    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
        <label>Libellé :
            
        </label>
        <input disabled  class="form-control custom-input" placeholder="Libellé" autocomplete="off"
            [(ngModel)]="itemBareme.libelle" name="libelle" autocomplete="off" type="text" />
    </div>

    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
        <label>Description:
        </label>
        <textarea disabled  class="form-control custom-input" [(ngModel)]="itemBareme.description"
            name="description" placeholder="Description" id="" cols="30" rows="3"></textarea>
    </div>
</div>